import { object, string } from "yup";

export const DECLINE_REASON_CATEGORIES = {
	CAPACITY_OVER: "capacity_over",
	OTHER: "other",
	OUT_OF_AREA: "out_of_area",
	PRICE_DISAGREEMENT: "price_disagreement",
	SCHEDULE_MISMATCH: "schedule_mismatch"
} as const;

export type DeclineReasonCategory =
	(typeof DECLINE_REASON_CATEGORIES)[keyof typeof DECLINE_REASON_CATEGORIES];

const DECLINE_REASON_CATEGORY_VALUES = [
	DECLINE_REASON_CATEGORIES.OUT_OF_AREA,
	DECLINE_REASON_CATEGORIES.PRICE_DISAGREEMENT,
	DECLINE_REASON_CATEGORIES.CAPACITY_OVER,
	DECLINE_REASON_CATEGORIES.SCHEDULE_MISMATCH,
	DECLINE_REASON_CATEGORIES.OTHER
] as const satisfies readonly DeclineReasonCategory[];

export type DealPartnerAssignmentStatus = "pending" | "accept" | "decline";

export type DealPartnerAssignment = {
	declineReasonCategory: DeclineReasonCategory | null;
	declineReasonDetail: string | null;
	partnerVendorCompany: {
		id: number;
		name: string;
	};
	respondedAt: string | null;
	status: DealPartnerAssignmentStatus;
};

const DECLINE_REASON_LABELS = {
	capacity_over: "キャパシティオーバーのため",
	other: "その他",
	out_of_area: "対応エリア外のため",
	price_disagreement: "個社マニュアルの単価・運用について不合意のため",
	schedule_mismatch: "入居者の退去立会希望日程と合わないため"
} as const satisfies Record<DeclineReasonCategory, string>;

export const DECLINE_REASON_OPTIONS = DECLINE_REASON_CATEGORY_VALUES.map(
	(value) => ({
		label: DECLINE_REASON_LABELS[value],
		value
	})
);

export type AnswerType = "accept" | "decline";

export type PartnerAssignmentFormValues = {
	answerType: AnswerType;
	declineReasonCategory: DeclineReasonCategory | "";
	declineReasonDetail: string;
};

export type UpdateParams = {
	answerType: AnswerType;
	declineReasonCategory: DeclineReasonCategory | "";
	declineReasonDetail: string;
};

export const getDeclineReasonLabel = (
	category: DeclineReasonCategory
): string => DECLINE_REASON_LABELS[category];

export const partnerAssignmentResponseSchema = object().shape({
	answerType: string()
		.required("回答を選択してください")
		.oneOf(["accept", "decline"], "回答を選択してください"),
	declineReasonCategory: string().when("answerType", {
		is: "decline",
		// biome-ignore lint/suspicious/noThenProperty: Yupのwhen/then構文のため
		then: (schema) => schema.required("対応不可理由を選択してください")
	}),
	declineReasonDetail: string()
		.max(1000, "詳細理由は1,000文字以内で入力してください")
		.when("declineReasonCategory", {
			is: DECLINE_REASON_CATEGORIES.OTHER,
			// biome-ignore lint/suspicious/noThenProperty: Yupのwhen/then構文のため
			then: (schema) => schema.required("詳細理由を入力してください")
		})
});
